module.exports = __webpack_public_path__ + "img/electric_reserved_selected.5cada862.svg";